module.exports = __webpack_public_path__ + "img/Salsas.e2ff2e28.webp";